import styled from "styled-components";

import { theme } from "../../../themes/themes";
export const ButtonOfSettings = styled.button`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.neutral.gray[2200]};
  border: none;
  background: none;
  :focus,
  :hover {
    color: ${({ theme }) => theme.button.primary};
  }
`;
